export const environment = {
    production: false,
    apiUrl: 'https://volkshandwerker-api-qa.herokuapp.com/api',
    mapbox: {
      accessToken: 'pk.eyJ1Ijoidm9sa3NoYW5kd2Vya2VyIiwiYSI6ImNrbm03NDg0ZDBraGQzMXFwdDJ0dG80eHEifQ.DZWxvdWOzqeVIzOSa9ngwg'
    },
    environmentName: 'QA'
  };